@let isDownloading = downloadPlugin.feature.selectors.isDownloading.asSignal();

@if (reportSg(); as report) {
  <atn-ds-page [scrollable]="true">
    <atn-ds-page-header
      [name]="report.name"
      [breadcrumbs]="breadcrumbsSg()"
      pageHeader
    >
      <ng-container actions>
        <atn-ds-button
          [isIcon]="true"
          [type]="PredefinedStyleEnum.White"
          [disabled]="isDownloading"
          (click)="downloadClickHandler()"
        >
          <i class="atn-icon atn-download atn-blue"></i>
        </atn-ds-button>
      </ng-container>

      @let reportIdx = reportIdxSg();
      <atn-ds-page-header-pagination
        [currentPage]="reportIdx === undefined ? 0 : reportIdx + 1"
        [totalPages]="numberOfPagesSg()"
        (decrement)="previousPageClickHandler()"
        (increment)="nextPageClickHandler()"
        centered
      ></atn-ds-page-header-pagination>
    </atn-ds-page-header>

    @switch (report.id) {
      @case (ReportId.AccountList) {
        <atn-space-report-account-list />
      }
      @case (ReportId.DataExport) {
        <atn-space-report-data-export />
      }
      @case (ReportId.EmployeeList) {
        <atn-space-report-employee-list />
      }
      @case (ReportId.RoomLinks) {
        <atn-space-report-room-links />
      }
      @case (ReportId.RoomSupportingInformation) {
        <atn-space-report-room-supporting-information />
      }
      @case (ReportId.RoomsByAccount) {
        <atn-space-report-rooms-by-account />
      }
      @case (ReportId.RoomsByOccupant) {
        <atn-space-report-rooms-by-occupant />
      }
      @case (ReportId.RoomsByResponsiblePerson) {
        <atn-space-report-rooms-by-responsible-person />
      }
      @case (ReportId.SpaceSalaryComparison) {
        <atn-space-report-space-salary-comparison />
      }
      @case (ReportId.UnassignedSponsoredAccounts) {
        <atn-space-report-unassigned-sponsored-accounts />
      }
      @case (ReportId.UnassignedSponsoredPeople) {
        <atn-space-report-unassigned-sponsored-people />
      }
      @case (ReportId.ProgressByOrganization) {
        <atn-space-report-progress-by-organization />
      }
      @case (ReportId.UnclaimedRooms) {
        <atn-space-report-unclaimed-rooms />
      }
      @default {
        <atn-ds-widget
          class="atn-space-report__empty-state-widget"
          [title]="report.name"
        >
          <div class="atn-space-report__empty-state">
            <atn-ds-empty-state
              type="no-data"
              title="Coming Soon"
              [description]="report.name + ' is not available yet.'"
              layout="h"
            />
          </div>
        </atn-ds-widget>
      }
    }
  </atn-ds-page>
}
